"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.noop = void 0;
const noop = (..._xs) => {
};
exports.noop = noop;
//# sourceMappingURL=noop.js.map